$(document).ready(function () {
    initSelects();
    initVideo();
    initContacts();
    initPartners();
    initRequestForm();
    initTables();
});

function resize() {
    initTables();
}

var timo;
window.onresize = function () {
    clearTimeout(timo);
    timo = setTimeout(resize, 100);
};

$('.navbar-toggler').click(function () {
    $(this).toggleClass('active');
    if ($(this).hasClass('active')) {
        $('header').addClass('open-nav');
        $('html').addClass('no-scroll');
    } else {
        $('header').removeClass('open-nav');
        $('html').removeClass('no-scroll');
    }
});

function initSelects() {
    var selects = $('select.styled:not(.done)');

    selects.each(function () {
        $(this).wrap('<div class="select-wrap"></div>');
        var wrap = $(this).parent();
        var selected = $(this).find(':selected');
        selected.attr('selected', true);

        var img = selected.data('image');
        var bg = ' <div class="bg-ico" style="background-image:url(' + img + ')"></div>';

        wrap.append('<div class="select-value' + (img ? ' has-image' : '') + '">' + (img ? bg : '') + selected.text() + '</div>');
        var html = '<div class="select-options">';
        $(this).find('option').each(function () {
            var img = $(this).data('image');
            var bg = ' <div class="bg-ico" style="background-image:url(' + img + ')"></div>';
            html += '<div class="option ' +
                $(this).attr('class') +
                ($(this).attr('selected') ? ' selected' : '') + '"' +
                ' data-value="' + $(this).val() + '">' +
                (img ? bg : '') +
                $(this).text() +
                '</div>';
        });
        html += "</div>";
        wrap.append(html);
        wrap.addClass($(this).attr('class'));
        $(this).addClass('done');

        if ($('.select-options', wrap).outerHeight() >= parseInt($('.select-options', wrap).css('max-height'))) {
            $('.select-options', wrap).mCustomScrollbar();
        }

        if (wrap.find('select').val() == $('option', wrap).eq(0).val()) {
            wrap.addClass('default');
        }
    });

    $('.select-wrap').each(function () {
        var value = $('.select-value', $(this));
        var opts = $('.option', $(this));
        var img = value.data('image');

        if (img != '' && img != 'undefined' && (value.css('background-image') == '' || value.css('background-image') == 'none')) {
            var bg = ' <div class="bg-ico" style="background-image:url(' + img + ')"></div>';
            value.addClass('has-image');
            value.prepend(bg);
        }

        opts.each(function () {
            var img = $(this).data('image');
            if (img != '' && typeof img != 'undefined' && $(this).find('.bg-ico').length == 0) {
                var bg = ' <div class="bg-ico" style="background-image:url(' + img + ')"></div>';
                $(this).prepend(bg);
            }
        });
    });

    $('select.styled').click(function () {
        $(this).parent().focus().toggleClass('clicked');
    });

    $('.select-value').click(function () {
        $(this).parent().focus().toggleClass('clicked');
    });

    var options = $('.select-options .option');
    options.click(function () {
        var wrap = $(this).parents('.select-wrap');
        var img = $(this).find('.bg-ico').css('background-image');
        var bg = $('<div class="bg-ico"></div>').css('background-image', img);
        wrap.removeClass('clicked').find('.select-value').html($(this).text());
        wrap.find('.select-value').removeClass('has-image');
        if (img) {
            wrap.find('.select-value').addClass('has-image').prepend(bg);
        }
        wrap.find('select').val($(this).attr('data-value')).change();
        $('.option', wrap).removeClass('selected');
        $(this).addClass('selected');

        if (wrap.find('select').val() == $('option', wrap).eq(0).val()) {
            wrap.addClass('default');
        }
        else {
            wrap.removeClass('default');
        }

    });

    $('.select-wrap').attr('tabindex', '1').focusout(function () {
        $(this).removeClass('clicked');
    });

    //find option by pressed keys
    var typingTimer;
    var doneTypingInterval = 700;
    var needle = '';

    $(".select-wrap").keypress(function (e) {
        needle += e.key;
        clearTimeout(typingTimer);
        selectWrap = $(this);

        typingTimer = setTimeout(function () {
            doneTyping(selectWrap);
        }, doneTypingInterval);
    });

    function doneTyping(selectWrap) {
        var opt = $('.option', selectWrap).filter(function () {
            var text = $(this).text().toLowerCase().replace(/\s/g, '');
            needle = needle.replace(/\s/g, '');
            return text.indexOf(needle) === 0;
        });
        if (opt.length > 0) {
            selectWrap.find('select-options').mCustomScrollbar('scrollTo', opt.eq(0).position().top);
            opt.eq(0).click();
        }
        needle = '';
    }
}

function initVideo() {
    var vid = $('.background video');

    if (vid.length < 1) {
        return;
    }
    vid.get(0).play();
    vidReset = 0;

    vid.get(0).addEventListener("timeupdate", function () {
        if (this.currentTime >= vid.data('reset-timeout')) {
            vidReset += 1;
            videoEnd();
        }
    });

    function videoEnd() {
        if (vidReset === 1) {
            vid.addClass('fade-out');

            setTimeout(function () {
                vid.removeClass('fade-out');
                vid.get(0).currentTime = 0;
                vid.get(0).play();
                vidReset = 0;
            }, 2000);
        }
    }
}

function initContacts() {
    var wrap = $('section.contacts');
    var blocks = $('.contact-block');

    blocks.mouseenter(function () {
        var img = $(this).data('image');
        var bg = 'url("' + img + '")';

        if (wrap.css('background-image').indexOf(img) >= 0) {
            return;
        }

        wrap.addClass('loading');

        setTimeout(function () {

            wrap.css({
                'background-image': bg
            });
            wrap.removeClass('loading');
        }, 200);
    });

    $('.content', wrap).each(function () {
        $(this).css('height', $(this).outerHeight());
        if ($('.content', wrap).index($(this)) != 0) {
            $(this).addClass('hidden');
        }
    });

    $('h4', wrap).click(function () {
        $('.content').addClass('hidden');
        $(this).siblings('.content').removeClass('hidden');
    });
}

function initPartners() {
    var container = $('.partner-container');

    var owl = container.addClass('owl-carousel').owlCarousel({
        loop: true,
        autoplay: true,
        items: 6,
        margin: 30,
        slideTransition: 'linear',
        autoplayTimeout: 3000,
        autoplaySpeed: 2000,
        responsive: {
            0: {
                items: 2
            },
            480: {
                items: 3
            },
            575: {
                items: 4
            },
            767: {
                items: 5
            },
            991: {
                items: 6
            }

        }
    });
}

function initRequestForm() {
    initSteps();
    initSelects();
    initDates();
    initCustomFile();

    customFileLimit = 4;  //failu lauku limits
    customFileCounter = 1; //failu skaitītājs, kas atbild par inputu id un labeliem

    function initSteps() {
        var wrap = $('.request-form form');
        var steps = $('.step', wrap);
        var stepNavItems = $('.step-nav-item', wrap);
        var nextButtons = $('.next-step', wrap);
        currentStep = 0;

        $('input, select, textarea').change(function () {
            $(this).removeClass('error');
        });

        stepNavItems.click(function () {
            targetStep = parseInt($(this).children('a').eq(0).attr('href').split('-')[1]) - 1;
            changeStep(targetStep);
            return false;
        });

        nextButtons.click(function () {
            if (currentStep <= steps.length - 1) {
                changeStep(parseInt(currentStep) + 1);
            }
            return false;
        });

        function changeStep(targetStep) {
            var valid = validateStep(currentStep);
            if (targetStep > currentStep) {
                if (!valid) {
                    return;
                }
            }

            var st = $(window).width() < 991 ? $('.request-form').eq(0).offset().top - $('header').outerHeight() : $('.request-form').eq(0).offset().top;
            $(window).scrollTop(st);

            steps.removeClass('active');
            steps.eq(targetStep).addClass('active');
            stepNavItems.removeClass('active');
            stepNavItems.eq(targetStep).addClass('active');
            currentStep = targetStep;
        }

        function validateStep(index) {
            var wrap = steps.eq(index);
            var fields = $('input, select, textarea', wrap);
            var validStep = true;

            fields.removeClass('error');
            fields.each(function () {
                if ($(this).is(':required') && ($(this).val() == '' || $(this).val() == null)) {
                    $(this).addClass('error');
                    validStep = false;
                }

                if ($(this).val() != '' && $(this).val() != null) {
                    if ($(this).attr('pattern')) {
                        var regexp = new RegExp($(this).attr('pattern'));
                        if (!regexp.test($(this).val())) {
                            $(this).addClass('error');
                            validStep = false;
                        }
                    }

                    if ($(this).attr('type') == 'email') {
                        var regexp = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
                        if (!regexp.test($(this).val())) {
                            $(this).addClass('error');
                            validStep = false;
                        }
                    }
                }
            });

            if(!validStep){
                var st = $(window).width() < 991 ? fields.filter('.error').eq(0).offset().top-20 - $('header').outerHeight() : fields.filter('.error').eq(0).offset().top-20;
                $(window).scrollTop(st);
            }

            return validStep;
        }
    }

    function initSelects() {
        $('.select-multi').select2({
            tags: true,
            createTag: function (params) {
                return {
                    id: params.term,
                    text: params.term,
                    newOption: true
                }
            }
        });

        $('.select').select2({
            minimumResultsForSearch: Infinity
        });
    }

    function initDates() {
        $('.datepicker').datepicker({
            dateFormat: "dd-mm-yy"
        });
    }

    function initCustomFile() {
        //pieglabā templeitu
        if (typeof customFilePrototype == 'undefined') {
            customFilePrototype = $('.file-input-row').eq(0).clone();
        }

        var fileRows = $('.file-input-row');

        //iziet cauri katrai rindai un pievieno eventus
        $('.file-input-row').each(function () {
            var wrap = $(this);
            var fileInput = $('input[type="file"]', this);
            var label = $('label[for="' + fileInput.attr('id') + '"]');
            var addedClass = "file-added";
            var placeholder = $('.placeholder', this);

            label.off('click').click(function () {
                if ($(this).hasClass(addedClass)) {
                    fileInput.val('');
                    fileInput.change();
                    return false;
                }
            });

            fileInput.off('change').change(function () {
                var filename = fileInput.val().split(/(\\|\/)/g).pop();
                setTimeout(function () {
                    wrap.addClass('trans');
                    wrap.blur();
                }, 500);


                if (filename != '') {
                    placeholder.html('<span class="filename">' + filename + '</span>');
                    label.addClass('delete').text('');
                    label.addClass(addedClass);
                }
                else {
                    wrap.remove();
                    $('.filename', wrap).remove();
                    label.removeClass('delete').text(label.data('text-default'));
                    placeholder.html(placeholder.data('text-default'));
                    label.removeClass(addedClass);
                }

                checkLast();
                //izsauc sevi, lai pievienotu eventus arī jaunajām rindām
                initCustomFile();
            });
        });

        function checkLast() {
            var fileRows = $('.file-input-row');
            var lastFileRow = fileRows.eq(fileRows.length - 1);
            var lastIndex = fileRows.index(lastFileRow);
            var lastInput = $('input[type="text"]');
            var emptyFileInput = false;

            //neļauj pārsniegt limitu
            if (fileRows.index(lastFileRow) == customFileLimit - 1) {
            } else {
                //pēc beidzamās rindas tiek pievienota jauna tukša faila rinda
                var tmpRow = customFilePrototype.clone();
                tmpRow.find('label[for="file-image"]').attr('for', 'file-image-' + customFileCounter);
                tmpRow.find('input[type="file"]').attr('name', 'file-image-' + customFileCounter).attr('id', 'file-image-' + customFileCounter);
                lastFileRow.after(tmpRow);

                //izņem liekās tukšās rindas
                fileRows = $('.file-input-row');
                fileRows.each(function () {
                    if ($('label[for^="file-image"]', this).hasClass('file-added')) {
                    } else {
                        lastFileRow.after($(this));
                        if (emptyFileInput) {
                            $(this).remove();
                        }
                        emptyFileInput = true;
                    }
                });
                customFileCounter++;
            }
        }
    }
}

var tables = $('.main-wrap table');
var tableWidths = {};

function initTables(){

    tables.each(function(){
        if(!$(this).hasClass('inited')){
            tableWidths[$(this).index()] = $(this).width();
        }
        if(tableWidths[$(this).index()] <= $(this).parent().width()){
            $(this).show();
            $(this).next('.new-table').hide();
            return;
        }else{
            if($(this).hasClass('inited')){
                $(this).hide();
                $(this).next('.new-table').show();
                return;
            }
        }

        var table = $(this);
        var headers = $('th', table);
        var rows = $('tr', table);
        var newTable = '<div class="new-table">';

        rows.each(function(){
            var row = $(this);
            if($('th', row).length>0){
                return;
            }
            var cells = $('td',  row);
            newTable += '<table class="table-row">'

            cells.each(function(){
                var cellIndex = cells.index($(this));
                newTable += '<tr class="cell-row">';
                if(headers.eq(cellIndex, headers)){
                    newTable += '<td class="th">'+headers.eq(cellIndex, headers).html()+'</td>';
                }
                newTable += '<td class="td">'+$(this).html()+'</td>';
                newTable += '</tr>';

            });

            newTable += '</table>';
        });

        newTable += '</div>';

        table.after(newTable);
        table.addClass('inited');
        table.hide();
    });
}